<div mat-dialog-content class="modal-container flex flex-col items-center justify-center gap-4">

  <!-- Estado de carga -->
  <ng-container *ngIf="!isSuccess; else successTemplate">
    <div class="spinner-container">
      <mat-progress-spinner color="primary" mode="indeterminate" diameter="70"></mat-progress-spinner>
    </div>

    <div class="loading-text">
      <h3 class="title font-semibold text-lg text-gray-800">Registrando tu cuenta...</h3>
      <p class="text-sm text-gray-600 mt-1 animate-pulse">{{ currentMessage }}</p>
    </div>
  </ng-container>

  <!-- Éxito -->
  <ng-template #successTemplate>
    <div class="success-container flex flex-col items-center text-center animate-fade-in">
      <mat-icon class="success-icon mb-3">check_circle</mat-icon>
      <h2 class="title font-semibold text-xl text-gray-800">¡Registro exitoso!</h2>
      <p class="text-gray-600 mb-4">Tu cuenta se ha creado correctamente.</p>

      <div mat-dialog-actions class="flex w-full button-accept">
        <button
          type="submit"
          mat-raised-button
          color="primary"
          class="w-2/3 py-2 rounded-lg"
          (click)="close()"
          [disabled]="loading"
        >
          <mat-icon iconPositionEnd [class.animate-spin]="loading">
            {{ loading ? 'autorenew' : 'login' }}
          </mat-icon>
          <span>{{ loading ? 'Iniciando...' : 'Aceptar' }}</span>
        </button>
      </div>
    </div>
  </ng-template>

</div>
